import { createTranslations } from '@npco/common-utils-translations'

export const translations = createTranslations({
  breadcrumb: 'Transfer',
  recentTransactionsLinkMobile: 'Repeat past transaction',
})

export const contactTransferTranslations = createTranslations({
  accountNameLabel: 'Account Name',
  accountNumberLabel: 'Account Number',
  accountBsbLabel: 'BSB',
  deFallbackMessage:
    'We weren’t able to confirm your recipient’s bank details, so please check your transfer details to ensure they’re correct before proceeding.',
  dailyMaxLimitTransferError:
    'This amount exceeds your Daily Maximum Limit. Please contact Zeller Support if you’d like to raise your limit.',
})

export const externalTransferTranslations = createTranslations({
  accountNameLabel: 'Account Name',
  nicknameLabel: 'Nickname (Optional)',
  accountBsbLabel: 'BSB',
  accountNumberLabel: 'Account Number',
  recipientDescriptionSummary: "Recipient's description or reference",
  recipientDescriptionPlaceholder: 'Up to 18 characters',
  referenceSummary: 'Your reference or description',
})

export const zellerTransferTranslations = createTranslations({
  amountLabel: 'Amount',
  referenceLabel: 'Reference for you',
  referenceSummary: 'Your reference',
  referencePlaceholder: 'Up to {maxLength} characters',
})

export const bPayTransferTranslations = createTranslations({
  transferFailed: 'Your transfer was unsuccessful. Please try again.',
})
